const mEditionAssetContentsComentModalReport = {
  mEditionAssetContentsComentModalReport: {
    alerts: {
      approveReport: {
        error: 'Un error ha ocurrido.',
        success: 'Reporte aprobado!'
      },
      disapproveReport: {
        success: 'Reporte rechazado!'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimaryApprove: 'APROBAR',
    buttonPrimaryDisapprove: 'RECHAZAR',

    inputs: {
      respuesta: {
        label: 'Respuesta'
        // message: '* De 5 a 255 caracteres'
      }
    },

    titleApprove: 'Aprobar Reporte',
    titleDisapprove: 'Rechazar Reporte',

    validation: {
      respuesta: {
        // maxLength: 'La longitud máxima permitida es de 255 caracteres.',
        // minLength: 'La longitud mínima permitida es de 5 caracteres.',
        required: 'La respuesta es requerida.'
      }
    }
  }
}
export default mEditionAssetContentsComentModalReport
